import React from "react";
import capitalize from "lodash/capitalize";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "src/components/Dialog";

import { StatefulLoadableButton } from "src/components/LoadableButton";
import { getPoshmarkUser } from "src/utils/extension/poshmark";
import { getMercariUser } from "src/utils/extension/mercari";
import { getWhatnotUser } from "src/utils/extension/whatnot";
import { getVintedUser } from "src/utils/extension/vinted";
import { getDepopUser } from "src/utils/extension/depop";
import usePrevious from "src/utils/usePrevious";

function Content({ onClose, platform: _platform }) {
  const platformMemory = usePrevious(_platform);
  const platform = _platform || platformMemory || "poshmark";
  const capitalizedPlatform = platform
    .split("-")
    .map((p) => capitalize(p))
    .join(" ");
  return (
    <>
      <DialogTitle>Log In to {capitalizedPlatform}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          To import your data from {capitalizedPlatform}, you’ll need to be
          logged into {capitalizedPlatform}. Click below to log in.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StatefulLoadableButton
          color="primary"
          autoFocus
          onClick={async () => {
            if (platform === "poshmark") await getPoshmarkUser();
            else if (platform === "mercari") await getMercariUser();
            else if (platform === "whatnot") await getWhatnotUser();
            else if (platform === "vinted") await getVintedUser();
            else if (platform === "depop") await getDepopUser();
            onClose();
          }}
        >
          Log In
        </StatefulLoadableButton>
      </DialogActions>
    </>
  );
}

function PoshmarkLogInDialog({
  open,
  onClose,
  platform = "poshmark",
}: {
  open: boolean;
  onClose: () => void;
  platform?: "poshmark" | "mercari" | "whatnot" | "vinted" | "depop";
}) {
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <Content onClose={onClose} platform={platform} />
    </Dialog>
  );
}

export default PoshmarkLogInDialog;
